import React, { useState } from "react";
import { FaStar, FaUser } from "react-icons/fa";
import EAButton from "../../../app/components/shared/Buttons/EAButton";
import ChangePassword from "../../../app/components/MyAccount/ChangePassword";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../../app/store/auth/authActions";
import { State } from "../../../app/store";
import useFacility from "../../../utils/hooks/useFacility";
import EAModal from "../../../app/components/shared/Modal/EAModal";
import { useNavigate } from "react-router-dom";
import { LOGIN_PAGE } from "../../../app/routes";

declare const config: { B2B_URL: string };

export const B2B_URL = (config && config.B2B_URL) || "http://localhost:8080/eaktywnib2b";

const B2BNavButton: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const userData = useSelector((state: State) => state.auth.userData);
  const facilityIds = useFacility();
  const { configuration } = useSelector((state: State) => state.config);

  const onClick = () => {
    setOpen(!open);
  };

  const handleLogOut = () => {
    dispatch(logOut());
    window.location.href = `${B2B_URL}?objectIds=${facilityIds}`;
  };

  const handleMyAccount = () => {
    setOpen(false);
    navigate(LOGIN_PAGE);
  };

  return (
    <>
      <EAButton
        title={"Partner B2B"}
        variant={"outlined"}
        onClick={onClick}
        startIcon={<FaStar title={"Partner B2B"} />}
        fullWidth={!configuration.widgetActive}
      />
      {open && (
        <EAModal isOpen={open} onClose={() => setOpen(false)} title={"Partner B2B"} hideButtons onAccept={() => {}}>
          <div
            style={{
              width: "30vw",
              minWidth: "280px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              padding: "8px 0",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "8px",
              }}
            >
              <p className="text-color-dark-gray">
                Adres email: <b className="text-color-dark text-weight-bold">{userData.email}</b>
              </p>
            </div>

            <EAButton title="Moje konto" onClick={handleMyAccount} fullWidth variant="filled" startIcon={<FaUser />} />

            <ChangePassword b2bPartner />

            <EAButton title={t("wyloguj_sie")} onClick={() => handleLogOut()} fullWidth variant="text" color="error" />
          </div>
        </EAModal>
      )}
    </>
  );
};

export default B2BNavButton;
